import styled from 'styled-components';

import { NavigationLink } from '../../Link/NavigationLink';
import { theme } from '../../ui/theme';

export const SidebarNavigationItem = styled(NavigationLink)`
    height: 32px;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: ${theme.space[8]};
    padding-right: ${theme.space[8]};
    color: ${theme.colors.foreground.muted};
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[500]};
    line-height: 24px;
    border-radius: ${theme.radii[8]};

    &:before {
        content: '';
        opacity: 0;
        position: absolute;
        left: -16px;
        top: 8px;
        width: 2px;
        height: 16px;
        background-color: ${theme.colors.accent.foreground};
        border-radius: ${theme.radii[8]};
        transform: scale(0.2);
        transition:
            opacity 75ms ease-in,
            transform 75ms ease-in;
    }

    &:hover,
    &:focus {
        color: ${theme.colors.foreground.default};
        text-decoration: none;
        background-color: ${theme.colors.background.inset};
    }

    &.active {
        color: ${theme.colors.accent.foreground};

        &:before {
            opacity: 1;
            transform: scale(1);
        }

        &:hover {
            background-color: ${theme.colors.accent.background};
        }
    }
`;
